import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useNavigate } from 'react-router-dom';
import { CTA, Modal, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import { COURSE_CANCEL } from '../../../../app/redux/actions/tutors';

export const ModalCancelCourseId = 'ModalCancelCourse';

const ModalCancelCourse = ({ mediaIsPhone, modalClose, courseCancel }) => {
  const scrollableAreaRef = useRef(null);
  const navigate = useNavigate();

  return (
    <Modal
      title="Esci dalla modalità di creazione"
      modalId={ModalCancelCourseId}
      scrollableAreaRef={scrollableAreaRef}
      compact
    >
      <ScrollableArea ref={scrollableAreaRef}>
        <Text type="h3" mb={16}>
          Sei sicuro di voler uscire dalla modalità di creazione?
        </Text>
        <Text type="b3">
          Cliccando su “conferma” perderai tutti i dati fino ad ora inseriti.
        </Text>
      </ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="annulla"
          fullsize={mediaIsPhone}
          onClick={modalClose}
        />
        <CTA
          type="primary"
          btnText="conferma"
          fullsize={mediaIsPhone}
          onClick={() => {
            courseCancel(navigate);
            modalClose();
          }}
        />
      </Footer>
    </Modal>
  );
};

ModalCancelCourse.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state

  // dispatch
  modalClose: PropTypes.func.isRequired,
  courseCancel: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      return {};
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      courseCancel: (navigate) =>
        dispatch({ type: COURSE_CANCEL._REQUEST, navigate }),
    })
  ),
  withMediaQueries
)(ModalCancelCourse);
